module.exports = __webpack_public_path__ + "img/lights_m.03530b99.png";